import axios from "axios";
import { API_URL } from "../../config";
import { getToken } from "../../utils/authManager";

export function _fetchProfile() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}user/profile`,{
        headers:{
          Authorization: getToken()
        }
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function _fetchOtherProfile(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}user/${id}`,{
        headers:{
          Authorization: getToken()
        }
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function _updateProfileDetails(data) {
  console.log(data);
  return new Promise((resolve, reject) => {
    axios
      .put(`${API_URL}user/update-user`, data,{
        headers:{
          Authorization: getToken()
        }
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
